import { FC } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import katzDigitallogo from 'src/assets/landing/katzDigitallogo.webp';
import PublicisLogo from 'src/assets/landing/PublicisLogo.png';
import LightLogo from 'src/assets/landing/LightLogo.png';
import HorizonMediaLogo from 'src/assets/landing/HorizonMediaLogo.png';
import betterhelpLogo from 'src/assets/landing/betterhelpLogo.svg';
import Acast2022 from 'src/assets/landing/Acast2022.png';
import OMDTransparent from 'src/assets/landing/OMDTransparent.png';
import Soundsprofitable from 'src/assets/landing/soundsprofitable.png';
import NewDaxLogo from 'src/assets/landing/NEW_DAX_LOGO.png';
import AdsWizzLogo from 'src/assets/landing/AdsWizzLogo.png';
import AmazonLogo from 'src/assets/landing/AmazonLogo.png';
import AudacyLogo from 'src/assets/landing/AudacyLogo.png';
import DaylightMediaLogo from 'src/assets/landing/DaylightMediaLogo.png';
import NPRLogo from 'src/assets/landing/NPRLogo.png';
import OmnicomLogo from 'src/assets/landing/OmnicomLogo.png';
import PRXLogo from 'src/assets/landing/PRXLogo.png';
import SpotifyLogo from 'src/assets/landing/SpotifyLogo.png';
import SXMMediaLogo from 'src/assets/landing/SXMMediaLogo.png';
import TheNewYorkTimeLogo from 'src/assets/landing/TheNewYorkTimeLogo.png';
import TheTradeDeskLogo from 'src/assets/landing/TheTradeDeskLogo.png';
import VoxLogo from 'src/assets/landing/VoxLogo.png';
import YahooLogo from 'src/assets/landing/YahooLogo.png';
import DentsuLogo from 'src/assets/landing/DentsuLogo.png';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      width: '100%',
      padding: '92px 0',
      background: '#EFEDEB',
    },
    mainContainer: {
      width: 'calc(100% - 8px)',
      margin: '0 4px',
      padding: '90px 16px',
      display: 'flex',
      flexDirection: 'column',
      background: '#E8E5E2',
      borderRadius: 2,
      gap: 60,
      overflow: 'hidden',

      '@media screen and (min-width: 768px)': {
        width: 'calc(100% - 32px)',
        margin: '0 16px',
        gap: 120,
        padding: '90px 100px',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
      },

      '& > div': {
        flex: 1,
      },
    },
    title: {
      maxWidth: 250,
      fontWeight: 700,
      fontSize: 16,
      lineHeight: '24px',
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      color: '#202226',
      margin: 0,

      '@media screen and (min-width: 560px)': {
        maxWidth: '100%',
        fontSize: 20,
        lineHeight: '40px',
      },
    },
    description: {
      fontWeight: 300,
      fontSize: 16,
      lineHeight: '24px',
      color: '#545454',
      margin: 0,

      '@media screen and (min-width: 768px)': {
        fontSize: 25,
        lineHeight: '40px',
      },
    },
    partners: {
      maxWidth: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: 20,
      animation: '$scroll 30s linear infinite',
      '&:hover': {
        animationPlayState: 'paused',
      },

      '@media screen and (min-width: 768px)': {
        animation: 'none',
        justifyContent: 'center',
        flexWrap: 'wrap',
        columnGap: 30,
        rowGap: 40,
      },

      '& img': {
        transition: 'transform .25s linear',
        '&:hover': {
          transform: 'scale(1.1);',
        },
      },
    },
    '@keyframes scroll': {
      '100%': {
        transform: 'translateX(-1200px)',
      },
    },
  })
);

const BarometerPartners: FC = () => {
  const classes = useStyles();

  const partners = [
    {
      logo: katzDigitallogo,
      link: 'https://katzdigital.com/',
      alt: 'katzDigitallogo',
      height: 60,
    },
    {
      logo: PublicisLogo,
      link: 'https://www.publicis.com/',
      alt: 'PublicisLogo',
      height: 55,
    },
    {
      logo: LightLogo,
      link: 'https://soundstack.com/',
      alt: 'LightLogo',
      height: 30,
    },
    {
      logo: HorizonMediaLogo,
      link: 'https://www.horizonmedia.com/',
      alt: 'HorizonMediaLogo',
      height: 55,
    },
    {
      logo: betterhelpLogo,
      link: 'https://www.betterhelp.com/',
      alt: 'betterhelpLogo',
      height: 30,
    },
    {
      logo: Acast2022,
      link: 'https://www.acast.com/',
      alt: 'Acast2022',
      height: 45,
    },
    {
      logo: OMDTransparent,
      link: 'https://www.omnicomgroup.com/',
      alt: 'OMDTransparent',
      height: 45,
    },
    {
      logo: Soundsprofitable,
      link: 'https://soundsprofitable.com//',
      alt: 'Soundsprofitable',
      height: 90,
    },
    {
      logo: NewDaxLogo,
      link: 'https://dax.global.com/us/',
      alt: 'NewDaxLogo',
      height: 80,
    },
    {
      logo: AdsWizzLogo,
      link: 'https://www.adswizz.com/',
      alt: 'AdsWizzLogo',
      height: 35,
    },
    {
      logo: AmazonLogo,
      link: 'https://www.amazon.com/',
      alt: 'AmazonLogo',
      height: 40,
    },
    {
      logo: AudacyLogo,
      link: 'https://audacyinc.com/',
      alt: 'AudacyLogo',
      height: 55,
    },
    {
      logo: DaylightMediaLogo,
      link: 'https://www.daylightmedia.com/',
      alt: 'DaylightMediaLogo',
      height: 70,
    },
    {
      logo: NPRLogo,
      link: 'https://www.npr.org/',
      alt: 'NPRLogo',
      height: 35,
    },
    {
      logo: OmnicomLogo,
      link: 'https://omnicommedia.com/',
      alt: 'OmnicomLogo',
      height: 50,
    },
    {
      logo: PRXLogo,
      link: 'https://www.prx.org/',
      alt: 'PRXLogo',
      height: 60,
    },
    {
      logo: SpotifyLogo,
      link: 'https://open.spotify.com/',
      alt: 'SpotifyLogo',
      height: 55,
    },
    {
      logo: SXMMediaLogo,
      link: 'https://www.siriusxmmedia.com/',
      alt: 'SXMMediaLogo',
      height: 60,
    },
    {
      logo: TheNewYorkTimeLogo,
      link: 'https://www.nytimes.com/',
      alt: 'TheNewYorkTimeLogo',
      height: 35,
    },
    {
      logo: TheTradeDeskLogo,
      link: 'https://www.thetradedesk.com/',
      alt: 'TheTradeDeskLogo',
      height: 30,
    },
    {
      logo: VoxLogo,
      link: 'https://www.voxmedia.com/',
      alt: 'VoxLogo',
      height: 55,
    },
    {
      logo: YahooLogo,
      link: 'https://www.yahoo.com/?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAAKvMyBlCa-YuicoGRBKk8a0UuI-AqSCSLtaa6dTk4LymTqya1v9MiYHkn4xVOuU8PvbO5bL_CtuYN_taR2XQEP3982xUhFscQ7bNeDilRRkgUmdOsJRVmf67yTRhJkH6KIM2oZXaaCN6IzvbUoxw4gJrKqpdAy8F0OYXS_-FLUXr',
      alt: 'YahooLogo',
      height: 100,
    },
    {
      logo: DentsuLogo,
      link: 'https://www.dentsu.com/',
      alt: 'DentsuLogo',
      height: 35,
    },
  ];

  return (
    <div className={classes.container}>
      <div className={classes.mainContainer}>
        <div>
          <p className={classes.title}>
            Trusted partnerships increase your ROI
          </p>
          <p className={classes.description}>
            Leverage your Barometer access across omnichannel partners and
            experience consistent transparency across digital channels
          </p>
        </div>
        <div className={classes.partners}>
          {partners.map((partner) => (
            <a
              key={partner.alt}
              href={partner.link}
              rel='noreferrer'
              target='_blank'
            >
              <img
                src={partner.logo}
                height={partner.height}
                alt={partner.alt}
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BarometerPartners;
